import { render, staticRenderFns } from "./downloadPg.vue?vue&type=template&id=50ca1954&scoped=true"
import script from "./downloadPg.vue?vue&type=script&lang=js"
export * from "./downloadPg.vue?vue&type=script&lang=js"
import style0 from "./downloadPg.vue?vue&type=style&index=0&id=50ca1954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ca1954",
  null
  
)

export default component.exports